export var RecurrentDebitFormEnum;
(function (RecurrentDebitFormEnum) {
    RecurrentDebitFormEnum["NAME"] = "name";
    RecurrentDebitFormEnum["DOCUMENT_TYPE"] = "documentType";
    RecurrentDebitFormEnum["IDENTIFICATION_NUMBER"] = "identificationNumber";
    RecurrentDebitFormEnum["BANK_ID"] = "bankId";
    RecurrentDebitFormEnum["ACCOUNT_TYPE"] = "accountType";
    RecurrentDebitFormEnum["ACCOUNT_NUMBER"] = "accountNumber";
    RecurrentDebitFormEnum["PHONE_NUMBER"] = "phoneNumber";
    RecurrentDebitFormEnum["EMAIL"] = "email";
})(RecurrentDebitFormEnum || (RecurrentDebitFormEnum = {}));
